/****************************************************
 * Module Name:  cluletProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CluletProxy {
  static GetAllClulet = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clulet",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleClulet = (cluletId, callback) => {
    let params = {
      id: cluletId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/clulet",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckCluletAvailable = (clulet, callback) => {
    let params = {
      clulet: clulet,
    };

    restAPICall(
      Constants.MANAGER_URL + "/clulet/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddClulet = (clulet, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clulet",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(clulet),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateClulet = (clulet, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clulet",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(clulet),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteClulet = (clulet, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clulet",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(clulet),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
